export const config = {
  id: 'frontend',
  icon: 'Code',
  color: 'blue',
  title: 'Frontend Developer',
  description: 'Build amazing user interfaces',
  department: 'Engineering',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux']
};
